import { useEffect, useState } from "react";

export function getDocumentVisibilityState(): DocumentVisibilityState {
  return typeof document === "undefined" ? "hidden" : document.visibilityState;
}

export function useDocumentVisibilityState(): DocumentVisibilityState {
  const [visibilityState, setVisibilityState] = useState(
    getDocumentVisibilityState,
  );

  useEffect(() => {
    if (typeof document === "undefined") return;
    const updateVisibilityState = (): void => {
      setVisibilityState(document.visibilityState);
    };
    document.addEventListener("visibilitychange", updateVisibilityState);
    updateVisibilityState();
    return () => {
      document.removeEventListener("visibilitychange", updateVisibilityState);
    };
  }, []);

  return visibilityState;
}
